import { createReducer, on, Action } from "@ngrx/store";
import { DocStereoTypeDto } from "../../models/DocStereoTypeDto";
import { retrievedDocStereoList, addNewDocStereoType} from "./doc-stereo-type-action";
import { AppState } from "./app.state";
import * as storage from '../storage';

export const initialState : ReadonlyArray<DocStereoTypeDto> = [];


const _dstReducer = createReducer(initialState, on(retrievedDocStereoList, (state, {docstereotypes: docStereoTypes}) => {
    return [...docStereoTypes];
}));

export function dstReducer(state:any, action:any) {
    return _dstReducer(state,action);
}




// ---------------------------------------------------------------------

export const intState: AppState  = {
    docstereotypes: storage.getItem('docstereotypes').docstereotypes,
    currentDocStereoType: new DocStereoTypeDto
}

const _docStTypeReducer = createReducer(intState, on(retrievedDocStereoList, (state,result) => ({docstereotypes: result.docstereotypes}))
//,on(addNewDocStereoType, (state, {docstereotype}) => ({...state, currentDocStereoType:docstereotype}))
);

export function docStTypeReducer(state:AppState | undefined, action: Action) : any {
    return _docStTypeReducer(state,action);
}

export const getAllDocStereoTypes = (state:AppState) => 
{
    return state.docstereotypes;
};